<!--
 * @Author: 仙道
 * @Date: 2022-08-06 22:00:20
 * @LastEditTime: 2023-08-21 21:58:23
 * @email: hao.li08@weimob.com
 * @Description: 
 * @FilePath: /iplus-iwt-fe/src/components/layouts/iFrameCache.vue
-->
<template>
  <div class="iframe-container">
    <iframe
      :id="`commentIframe${keys}`"
      :src="pageUrl"
      :style="{ height: iframeContainerHeight }"
      allowfullscreen="true"
      frameborder="0"
      mozallowfullscreen="true"
      msallowfullscreen="true"
      oallowfullscreen="true"
      ref="commentIframe"
      webkitallowfullscreen="true"
    />
  </div>
</template>

<script>
  import { urlEncode } from '@/utils/util'
  import Vue from 'vue'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import { mapActions } from 'vuex'
  import { mixin, mixinDevice } from '@/utils/mixin.js'
  export default {
    name: 'IframeAll',
    props: ['url', 'keys'],
    inject: ['closeCurrent'],

    data () {
      return {
        pageLoading: false,
        routerAppExpired: null,
        routerWatched: false,
        pageUrl: ''
      }
    },
    mixins: [mixin, mixinDevice],
    components: {},
    watch: {},
    computed: {
      iframeContainerHeight () {
        let deductHeight = 0

        // Header高度 (来自GlobalHeader组件)
        const headerHeight = 64

        // 多页签高度 (来自TabLayout组件的a-tabs，style="height:52px")
        const tabHeight = this.multipage ? 52 : 2

        // 根据布局模式计算不同的高度
        if (this.layoutMode === 'topmenu') {
          // 顶部菜单模式：可能需要额外减去顶部菜单的高度
          const fixedTopMenuHeight = 0 // 根据实际情况调整，如果顶部菜单有额外高度
          deductHeight = headerHeight + tabHeight + fixedTopMenuHeight
        } else {
          // 侧边菜单模式 (sidemenu)：只需要减去header和tab高度
          deductHeight = headerHeight + tabHeight
        }

        return `calc(100vh - ${deductHeight}px)`
      }
    },
    created () {
      this.goUrl()

      const unwatchRouter = this.$watch(
        '$route',
        function (v, n) {
          if (!this.routerWatched) {
            this.goUrl(this.url + urlEncode(v.query))
            this.handleIframe(v.meta)
            if (unwatchRouter) {
              unwatchRouter()
            }
          }
        },
        { immediate: true }
      )
    },
    mounted () {
      // iframe加载loading

      this.pageLoading = true
      if (this.routerWatched) {
        this.pageLoading = false
        return
      }
      let oCommentIframe = document.getElementById(`commentIframe${this.keys}`)

      oCommentIframe.onload = () => {
        this.pageLoading = false
      }

      //  if (this.$route.path.indexOf('orderCenter') < 0 || this.$route.path.indexOf('onLine') < 0) return
      // 工单message
    },

    methods: {
      ...mapActions({
        // changeTabsMeta: 'tabs/changeTabsMeta'
      }),
      load (query) {
        if (query.source || query.messageId) {
          this.$refs.commentIframe.contentWindow.postMessage({ type: 'qccAdd', data: query }, '*')
        } else {
          this.$refs.commentIframe.contentWindow.postMessage(
            {
              type: 'sendToken',
              data: {
                token: getToken()
              }
            },
            '*'
          )
        }
      },
      handleIframe (v) {
        // this.routerAppExpired = this.$store.getters.appExpired[v.module]
        this.routerWatched = true
        this.pageLoading = true
        // if (this.$route.name === 'voiceRobotIndex') this.setVoiceRot()
      },
      goUrl (url) {
        // let url = this.$route.meta.url
        // let id = this.$route.path
        // this.id = id
        //url = "http://www.baidu.com"
        console.log('------url------' + url)
        if (url !== null && url !== undefined) {
          //-----------------------------------------------------------------------------------------
          //url支持通过 ${token}方式传递当前登录TOKEN
          let tokenStr = '${token}'
          if (url.indexOf(tokenStr) != -1) {
            let token = Vue.ls.get(ACCESS_TOKEN)
            const page_url = url.replace(tokenStr, token)
            console.info('page_url===', page_url)
            this.pageUrl = page_url
          } else {
            this.pageUrl = url
          }
          //-----------------------------------------------------------------------------------------

          /*update_begin author:wuxianquan date:20190908 for:判断打开方式，新窗口打开时this.$route.meta.internalOrExternal==true */
          if (this.$route.meta.internalOrExternal != undefined && this.$route.meta.internalOrExternal == true) {
            this.closeCurrent()
            window.open(this.pageUrl)
          }
          /*update_end author:wuxianquan date:20190908 for:判断打开方式，新窗口打开时this.$route.meta.internalOrExternal==true */
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .iframe-container {
    iframe {
      width: 100%;
    }
    .el-loading-spinner {
      left: 50%;
      text-align: left !important;
    }
    background: #fff;
  }
  ._expired {
    width: 100%;
    .wscn-http404-container {
      width: 100%;
    }
  }
</style>
